import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';
export const CartsContext = createContext({});

function CartsProvider({ children }) {

    const [userData,setUserData] = useState()
    const [carts,setCarts] = useState([])
    const [cartRequest,setCartRequest] = useState()
    const [showModalRequest,setShowModalRequest] = useState(false)

    const getAll = async () => {
        const response = await api.get("cart/get/loss/")
        if(response.status == 200){
            setCarts(response.data)
        }

    }
    const get = async (id) => {
        const response = await api.get(`cart/get/cart/${id}`)

        if(response.status == 200){
            getUser(response.data[0].user_id)
            setCartRequest(response.data[0])
        }

    }
    const getUser = async (id) => {
        const response = await api.get(`panel/get/client/by/id/${id}`)
        if(response.status == 200){
            setUserData(response.data[0])
            setShowModalRequest(true)
        }
    }


    return (
        <CartsContext.Provider value={{
            getAll,
            get,
            setShowModalRequest,
            showModalRequest,
            carts,
            cartRequest,
            userData
            
            }}>
            {children}
        </CartsContext.Provider>
    );
}

export default CartsProvider;
